import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account-activated',
  templateUrl: './account-activated.component.html',
  styleUrls: ['./account-activated.component.scss']
})
export class AccountActivatedComponent {

  constructor(private router: Router) { }

  redirectNow(): void {
    this.router.navigate(['']);
  }
}
